import { SupportMessage, Text } from '@bridebook/aura';
import { BasicStorageManager } from '@bridebook/toolbox/src/storage-managers';
import { Link } from '@bridebook/web/app-shared/components/link/link';
import { UrlHelper } from '@bridebook/web/lib/url-helper';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import { Trans } from 'react-i18next';

const HIDE_ADD_GUESTS_TO_EVENTS_HINT_STORAGE_KEY = 'HIDE_ADD_GUESTS_TO_EVENTS_HINT';

export const hideAddGuestsToEventsHintStorage = BasicStorageManager<string>({
  storageKey: HIDE_ADD_GUESTS_TO_EVENTS_HINT_STORAGE_KEY,
});

type Props = {
  onLinkClick?: () => void;
};

export const EmptyGuestlistBanner = ({ onLinkClick }: Props) => {
  const { t } = useTranslation('weddingWebsite');

  const [showBanner, setShowBanner] = useState(!hideAddGuestsToEventsHintStorage.get());
  const handleClose = () => {
    setShowBanner(false);
    hideAddGuestsToEventsHintStorage.set('true');
  };

  if (!showBanner) {
    return null;
  }

  return (
    <SupportMessage title={t('emptyGuestList.banner.title')} onClose={handleClose} icon={false}>
      <Text variant="typo-sm">
        <Trans
          ns="weddingWebsite"
          i18nKey="emptyGuestList.banner.message"
          components={{
            anchor: (
              <Link
                className="font-bold text-indigo-crush"
                href={UrlHelper.guestlist.main}
                onClick={onLinkClick}
              />
            ),
          }}
        />
      </Text>
    </SupportMessage>
  );
};
